import React from "react";
import bengaluru from "../asset/BENGALURU.jpg";
import hyderabad from "../asset/HYDERABAD.jpg";
import mysore from "../asset/mysore.jpeg";
import ramanagara from "../asset/Ramanagara.jpg";
import kalyaniDark from "../asset/kalyani_dark.png";
import kandm from "../asset/m&k.png";
import Chennai from "../asset/Chennai.jpg"

export default function HomeIntroArea({ props }) {
  const currentYear = new Date().getFullYear();
  const { locations_h, locations_b, locations_m, locations_c } = props.state;
  return (
    <div className="hm2_ln_a">
      <div className="hm2_ln_b">
        <div className="hm2_ln_c">
          <img alt="Kalyani" className="hm2_ln_d" src={kalyaniDark} />
          <img alt="Maruti" className="hm2_ln_e" src={kandm} />
        </div>
        <div className="hm2_ln_f">
          <div className="hm2_ln_g">CHOOSE YOUR CITY</div>
          <div className="hm2_ln_h">
            <div
              className="hm2_ln_i"
              onClick={() => {
                if (locations_b.length > 0) {
                  localStorage.setItem("location", "Bengaluru");
                  props.setState({ location: locations_b[0] });
                }
              }}
            >
              <img alt="Bengaluru" className="hm2_ln_j" src={bengaluru} />
              <div className="hm2_ln_k">BENGALURU</div>
            </div>

            <div
              className="hm2_ln_i"
              onClick={() => {
                if (locations_m.length > 0) {
                  localStorage.setItem("location", "Mysore");
                  props.setState({ location: locations_m[0] });
                }
              }}
            >
              <img alt="Mysore" className="hm2_ln_j" src={mysore} />
              <div className="hm2_ln_n">MYSORE</div>
            </div>

            <div
              className="hm2_ln_i"
              onClick={() => {
                if (locations_h.length > 0) {
                  // localStorage.setItem("location", "Ramanagara");
                  // props.setState({ location: locations_r[0] });
                  localStorage.setItem("location", "Hydrabad");
                  props.setState({ location: locations_h[0] });
                }
              }}
            >
              <img alt="Hyderabad" className="hm2_ln_j" src={hyderabad} />
              {/* <img alt="Hyderabad" className="hm2_ln_j" src={ramanagara} /> */}
              {/* <div className="hm2_ln_n">RAMANAGARA</div> */}
              <div className="hm2_ln_n">HYDERABAD</div>
            </div>
           <div
            className="hm2_ln_i"
            onClick={() => {
              if (locations_h.length > 0) {
                localStorage.setItem("location", "Chennai");
                props.setState({ location: locations_c[0] });
              }
            }}
          >
            <img alt="Chennai" className="hm2_ln_j" src={Chennai} />
            <div className="hm2_ln_n">CHENNAI</div>
          </div>
          </div>
         
        </div>
        <div className="hm2_ln_p">
          <span>COPYRIGHT © {currentYear} KALYANI MOTORS PVT LTD, INDIA </span>
        </div>
      </div>
    </div>
  );
}
